export enum NestedContentFields {
    TabMenu = 'tabMenu',
    TabMenuItem = 'tabMenuItem',
    Items = 'items',
    Content = 'content',
    Benefits = 'benefits',
    PaymentMethodsGroup = 'paymentMethodsGroup',
    PaymentMethod = 'paymentMethod',
    PaymentMethods = 'paymentMethods',
    PartnersGroup = 'partnersGroup',
    Partner = 'partner',
    SocialGroup = 'socialGroup',
    SocialLink = 'socialLink',
    CollectionMapping = 'collectionMapping',
    CategoryMapping = 'categoryMapping',
    classification_occasion = "classification_occasion",
    classification_material = "classification_material",
    classification_size = "classification_size",
    classification_character="classification_character",
    benefit_bar_data = 'benefit_bar_data',
    Facets = 'facets',
    Sorting = 'sorting',
    FooterLink = 'footerLink',
    FooterLinksGroup = 'footerLinksGroup',
    Documents = 'documents',
    Forms = 'forms',
    Form = 'form',
    FormElements = 'formElements',
    RelatedForms = 'relatedforms',
    moominCart = 'moominCart',
    Labels = 'labels',
    customerinfo = 'customerinfo',
    shoppingcart = 'shoppingcart',
    payment = 'payment',
    shippingmethod = 'shippingmethod',
    product = 'product',
    Success = 'success',
    Error = 'error',
    Billing = 'billing',
    Cart = 'cart',
    CheckoutLogin= 'checkoutLogin',
    Payment = 'payment',
    articleItems ='articleItems',
    articleListItems = 'articleListItems',
    Shipping = 'shipping',
    ShippingTypes = 'shippingTypes',
    BackToShop = 'backToShop',
    ListSource = 'listSource',
    globalLabels = 'globalLabels',
    coveoFacets = 'coveoFacets',
    coveoFilters = 'coveoFilters',
    EmptyState = 'emptyState',
    Attachments = 'attachments',
    ContactInformation = 'contactInformation',
    RequestDetails = 'requestDetails',
    benefitBarData = 'benefitBarData',
  }

export enum LinkFields {
  Link = 'link',
  LinkUrl = 'linkUrl',
  LinkTo = 'linkTo',
  ForgotPasswordLink = 'forgotpasswordlink',
  ShoppingCartUrl = 'shoppingCartUrl',
  LinkSecondary = 'linkSecondary',
  LinkSecondaryUrl = 'linkSecondaryUrl',
  CheckoutUrl= 'checkoutUrl',
  ButtonUrl= 'buttonUrl',
}
export enum imageFields {
  Image = 'image',
  VideoPoster = 'videoPoster',
  MobileVideoPoster = 'mobileVideoPoster',
}
